import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsDriverMessages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      driver_messages_data: props.driver_messages_data || null,
      isLoadingDriverMessagesInfo: true
    };

    Echo.channel(
      'driver-messages-table-'+this.state.data.id
    ).
    listen(
      'NewDriverMessage',
      (e) => {
        this.getDriverMessages();
      }
    );
  }
  componentDidMount() {
    this.getDriverMessages();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      driver_messages_data: nextProps.driver_messages_data
    });
  }

  getDriverMessages() {
    let url = '/api/v1/portal/driver-messages/job/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driverMessagesJson) => {
        this.setState({
          driver_messages_data: driverMessagesJson,
          isLoadingDriverMessagesInfo: false,
        })
      });
    });
  }

  render() {
    let DriverMessages = [];
    if (this.state.driver_messages_data &&
      this.state.driver_messages_data.length > 0) {
      let jobId = this.state.data.id;

        this.state.driver_messages_data.map((currentmsg, index) => {
          DriverMessages.push(
                <div key={"job-"+index+'-driver-message-'+currentmsg.id}>
                  {currentmsg.message_content}
                </div>
          )
        });

    }else{
      DriverMessages.push(
        <div key={"job-"+this.state.data.id+'-driver-message-0'}>
          No messages from driver yet.
        </div>
      )
    }
    return (
      <div>
        {DriverMessages}
      </div>
    );
  }
}